import React, { Component } from "react";
import { Image } from "semantic-ui-react";
import Future from "./Future";

export default class Home extends Component {
  render() {
    return (
      <>
        <Image src={require("../../img/home/epowers.png")} />
        <Future lang={this.props.match.params.lang} />
      </>
    );
  }
}
